import * as React from 'react';
import styled from 'styled-components';
import { Input } from '../General/Input';
import { rem } from 'polished';

export interface Props {
  name?: string;
  type?: string;
  placeholder?: string;
  value: string;
  onFocus: any;
  onChange: any;
  isMobile?: boolean;
  [key: string]: any;
}

const SearchFormInput = React.forwardRef<HTMLInputElement, Props>(
  (props, ref) => {
    return <StyledInput {...props} ref={ref as any} />;
  },
);

SearchFormInput.displayName = 'SearchFormInput';

const StyledInput = styled(Input)`
  padding: ${rem(16)} ${rem(16)} ${rem(16)} ${rem(50)};

  @media only screen and (max-width: 1480px) {
    width: 400px;
  }

  @media only screen and (max-width: 1300px) {
    width: 350px;
  }

  ${({ theme }) => theme.media(0, 'sm')} {
    width: 100%;
    font-size: ${rem(14)};
    padding-top: ${rem(16)};
    padding-bottom: ${rem(16)};
    border: ${rem(1)} solid ${({ theme }) => theme.colors.borderColor};
  }
`;

export { SearchFormInput };
